import { useMemo } from 'react';

import { useConfig } from '../config';

import { resolveBrand, type Brand } from './resolve-brand';

/** Marca resolvida da config do domínio (pura e memorizada). */
export function useBrand(): Brand {
  const config = useConfig();
  return useMemo(() => resolveBrand(config as Record<string, unknown>), [config]);
}
